export default function Plot_Canvas() {
  return (
    <div>
      <h1>Plot_Canvas Component</h1>
    </div>
  );
}
